import React from "react";

import svg from "../../assets/images/icons/exclamation-red-lage.svg";

export const ExclamationRedLargeIcon: React.FC<React.ImgHTMLAttributes<HTMLImageElement>> = ({ alt, ...restProps }) => (
    <img
        {...restProps}
        src={svg}
        alt={alt || "Exclamation"}
    />
);
